import Header from 'components/ModalCancelOrder/Sections/Header/styled';

export default Header;
